import { FC } from 'react'
import { formatDateToMoscow } from 'src/helpers/dates'

import { OrderFilterDateRange } from './components/OrderFilterDateRange'
import { OrderFilterDateSelect } from './components/OrderFilterDateSelect'
import { OrderFilterFilterModal } from './components/OrderFilterFilterModal'
import { OrderFilterLabel } from './components/OrderFilterLabel'
import { OrderFilterMobileFilterTrigger } from './components/OrderFilterMobileFilterTrigger'
import { OrderFilterMobileSearchFields } from './components/OrderFilterMobileSearchFields'
import { OrderFilterModeToggle } from './components/OrderFilterModeToggle'
import { OrderFilterPaymentStatusSelect } from './components/OrderFilterPaymentStatusSelect'
import { OrderFilterResetButton } from './components/OrderFilterResetButton'
import { OrderFilterSearchFields } from './components/OrderFilterSearchFields'
import { OrderFilterSearchInput } from './components/OrderFilterSearchInput'
import { OrderFilterStatusSelect } from './components/OrderFilterStatusSelect'
import { useOrderFilter } from './hooks/useOrderFilter'
import { OrderFilterProps } from './types'

import s from './OrderFilter.module.less'

export const OrderFilter: FC<OrderFilterProps> = (props) => {
  const {
    isSearchMode,
    isFilterMode,
    hasActiveFilters,
    statusDisplayText,
    paymentStatusDisplayText,
    orderCountText,
    hasActiveFiltersBadge,

    isLaptop,
    isTablet,
    isLargeLaptop,
    isLoading,

    allFilterLength,
    departureDateFrom,
    departureDateTo,
    status,
    paymentStatus,
    search,
    departure,
    destination,
    id,

    handleOpenFilter,
    handleSetMode,
    handleSetSearch,
    handleResetFilter,
    handleSwapPoints,
    handleSetDeparture,
    handleSetDestination,
    handleSetDepartureDateFrom,
    handleSetDepartureDateTo,
    handleSetStatus,
    handleSetPaymentStatus,
    handleCloseFilter
  } = useOrderFilter(props)

  const filterDepartureDatesLabel = (
    <OrderFilterLabel count={departureDateFrom || departureDateTo ? 1 : 0} title="Погрузка">
      {departureDateFrom && !departureDateTo ? `от ${formatDateToMoscow(departureDateFrom)}` : ''}
      {departureDateTo && !departureDateFrom ? `до ${formatDateToMoscow(departureDateTo)}` : ''}
      {departureDateFrom && departureDateTo
        ? `${formatDateToMoscow(departureDateFrom)} — ${formatDateToMoscow(departureDateTo)}`
        : ''}
    </OrderFilterLabel>
  )

  const filterStatusLabel = (
    <OrderFilterLabel count={status?.length} title="Статус">
      {statusDisplayText}
    </OrderFilterLabel>
  )

  const filterPaymentStatusLabel = (
    <OrderFilterLabel count={paymentStatus?.length} title="Оплата">
      {paymentStatusDisplayText}
    </OrderFilterLabel>
  )

  const mobileSearchFields = (
    <OrderFilterMobileSearchFields
      departure={departure}
      destination={destination}
      onSetDeparture={handleSetDeparture}
      onSetDestination={handleSetDestination}
      onSwapPoints={handleSwapPoints}
    />
  )

  const content = (
    <div className={s.filtersBlock} data-test-id="order--filter">
      {!isLaptop && (
        <OrderFilterModeToggle
          isLargeLaptop={isLargeLaptop}
          isSearchMode={isSearchMode}
          onToggle={() => handleSetMode(isSearchMode ? 'filter' : 'search')}
        />
      )}
      {isFilterMode ? (
        <>
          <div className={s.searchs}>
            {isLaptop ? (
              <OrderFilterDateRange
                departureDateFrom={departureDateFrom}
                departureDateTo={departureDateTo}
                isLaptop={isLaptop}
                onPickFrom={handleSetDepartureDateFrom}
                onPickTo={handleSetDepartureDateTo}
              />
            ) : (
              <OrderFilterSearchFields
                departure={departure}
                destination={destination}
                onSetDeparture={handleSetDeparture}
                onSetDestination={handleSetDestination}
                onSwapPoints={handleSwapPoints}
              />
            )}
          </div>
          <div className={s.filterSelects}>
            <OrderFilterDateSelect
              departureDateFrom={departureDateFrom}
              departureDateTo={departureDateTo}
              isLaptop={isLaptop}
              label={filterDepartureDatesLabel}
              mobileSearchFields={mobileSearchFields}
              onPickFrom={handleSetDepartureDateFrom}
              onPickTo={handleSetDepartureDateTo}
            />
            <OrderFilterStatusSelect
              isLaptop={isLaptop}
              onChange={handleSetStatus}
              prefix={filterStatusLabel}
              status={status}
            />
            <OrderFilterPaymentStatusSelect
              isLaptop={isLaptop}
              onChange={handleSetPaymentStatus}
              paymentStatus={paymentStatus}
              prefix={filterPaymentStatusLabel}
            />
            {hasActiveFilters && (
              <OrderFilterResetButton isLaptop={isLaptop} isLoading={isLoading} onReset={handleResetFilter} />
            )}
          </div>
        </>
      ) : (
        !isLaptop && (
          <OrderFilterSearchInput
            inputClassName="w-[480px]"
            onSetSearch={handleSetSearch}
            search={search}
            size={isLargeLaptop ? 'lg' : 'nm'}
          />
        )
      )}
    </div>
  )

  if (isLaptop) {
    return (
      <>
        <OrderFilterMobileFilterTrigger
          allFilterLength={allFilterLength}
          hasBadge={hasActiveFiltersBadge}
          isSearchMode={isSearchMode}
          isTablet={isTablet}
          onFilterClick={() => handleSetMode('filter')}
          onOpenFilterModalClick={handleOpenFilter}
          onSearchClick={() => handleSetMode('search')}
          onSetSearch={handleSetSearch}
          search={search}
        />
        <OrderFilterFilterModal id={id} onClose={handleCloseFilter} orderCountText={orderCountText}>
          {content}
        </OrderFilterFilterModal>
      </>
    )
  }

  return <>{content}</>
}
